export default __webpack_public_path__ + "static/media/NotoSansCS-Regular.0ae52b5f.ttf";